class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.addEventListener('click', (evt) => {
      evt.target.classList.contains('cart-drawer-tab') ? this.tabClick(evt.target) : null;
    });
    this.querySelector('#cart-drawer-overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.cart = document.querySelector('cart-drawer');
    this.form = document.querySelector('#cart-drawer-form');
    this.giftBoxes = new GiftBoxes();
    this.storefrontAPI = new API('storefront');
    document.querySelector('[data-heart]').addEventListener('click', (event) => this.open(event.currentTarget));
    this.giftSlidersProducts = {
      "level-1-step-1-free-gift-product": [],
      "level-1-step-2-free-gift-product": [],
      "level-2-step-1-free-gift-product": []
    }
    this.giftSlidersProductsTags = Object.keys(this.giftSlidersProducts);
  }

  showWishlist() {
    const giftPriceRemainderContainer = this.querySelector('.gift-price-remainder-container');
    this.querySelector('component-cart-drawer-wishlist').classList.remove('hidden');
    giftPriceRemainderContainer && giftPriceRemainderContainer.classList.add('hidden');
    this.querySelector('cart-drawer-items').classList.add('hidden');
    if(this.querySelector('.gift-box-container')) {
      this.querySelector('.gift-box-container').classList.add('hidden');
    }
    this.querySelector('.drawer-footer').classList.add('hidden');
    this.querySelector('.cart-drawer-empty-inner') && this.querySelector('.cart-drawer-empty-inner').classList.add('hidden');
    document.querySelector('component-cart-drawer-wishlist').render();
    this.querySelector('.cart-drawer-tab[data-tab="wishlist"]').classList.add('active');
    this.querySelector('.cart-drawer-tab[data-tab="basket"]').classList.remove('active');
  }

  showBasket() {
    const giftPriceRemainderContainer = this.querySelector('.gift-price-remainder-container');
    this.querySelector('component-cart-drawer-wishlist').classList.add('hidden');
    giftPriceRemainderContainer && giftPriceRemainderContainer.classList.remove('hidden');
    this.querySelector('cart-drawer-items').classList.remove('hidden');
    if(this.querySelector('.gift-box-container')) { 
      this.querySelector('.gift-box-container').classList.remove('hidden');
    }
    this.querySelector('.drawer-footer').classList.remove('hidden');
    this.querySelector('.cart-drawer-empty-inner') && this.querySelector('.cart-drawer-empty-inner').classList.remove('hidden');
    this.querySelector('.cart-drawer-tab[data-tab="wishlist"]').classList.remove('active');
    this.querySelector('.cart-drawer-tab[data-tab="basket"]').classList.add('active');
  }
  
  tabClick(drawerTab) {
    drawerTab.dataset.tab === 'basket' 
      ? this.showBasket()
      : this.showWishlist();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('[data-cart]');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  calculateVariantOptionsWidths() {
    setTimeout(() => {
      this.cartDrawerRecommendedProductsOptions = this.querySelectorAll('.component-product-options-boxes');
      for (const option of this.cartDrawerRecommendedProductsOptions) {
        option.checkWidth();
      }
    });
  }

  async open(triggeredBy) {    
    if(!triggeredBy || triggeredBy.classList.contains('cart')) {
      if(!this.productsByTagSettingUp) {
        await this._setupProductsByTag();
        await this._setFreeGiftPopupShouldShowModalProperty()
        this.productsByTagSettingUp = true;
        this.showBasket();
      }
      setTimeout(this.calculateVariantOptionsWidths.bind(this), 500);
    } else {
      this.showWishlist();
    }

    if (triggeredBy) this.setActiveElement(triggeredBy);
    setTimeout(() => {this.classList.add('animate', 'active')});
    document.body.classList.add('overflow-hidden');
  }

  close() {
    localStorage.setItem('freeGiftPercentRemainder', 0);
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  async renderContents(parsedState) {
    const dataFreeGiftPupupEnableDisable = (this.dataset.freeGiftPupupEnableDisable === 'true');
    const cartItemsToggleFreeGiftPopup = this.querySelector("cart-drawer-items").toggleFreeGiftPopup;
    if (this.querySelector('.cart-drawer-content').classList.contains('is-empty')) {
      this.querySelector('.cart-drawer-content').classList.remove('is-empty');
    }
    this.productId = parsedState.id;
    for (const section of this.getSectionsToRender()) {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
      this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }
    return new Promise((resolve) => {
      setTimeout(() => {
        this.querySelector('#cart-drawer-overlay').addEventListener('click', this.close.bind(this));
        this.open();
        dataFreeGiftPupupEnableDisable && cartItemsToggleFreeGiftPopup();
        this.giftBoxes._attachDynamicEvents();
        resolve(true);
      });
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#cart-drawer',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '#cart-icon-bubble',
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  _preRenderCartDrawer(parsedState) {
    for (const section of this.getSectionsToRender()) {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }
    this.querySelector('#cart-drawer-overlay').addEventListener('click', this.close.bind(this));
  }

  async _getProductsByTag(tag) {
    const queries = {
      first: 250,
      query: "tag:" + tag + " AND available_for_sale:true",
    };
    const fields = `{
      id
      title
      onlineStoreUrl
      featuredImage {
        url
      }
      variants(first: 10) {
        edges {
          node {
            id
            title
            availableForSale
          }
        }
      }
    }`;
    const countryCode = Shopify.country;
    const response = await this.storefrontAPI.getProducts(queries, fields, countryCode);
    const edges = response.data.products.edges.filter(product => product.node.onlineStoreUrl !== null);	
    return edges;
  }

  async _setupProductsByTag() {
    const giftSlidersProductsTagsResponses = [];
   
    for(let giftSlidersProductsTag of this.giftSlidersProductsTags) {
      let giftSlidersProductsTagsResponse =  this._getProductsByTag(giftSlidersProductsTag);
      let products = await giftSlidersProductsTagsResponse;
      this.giftSlidersProducts[giftSlidersProductsTag] = products;
      giftSlidersProductsTagsResponses.push(giftSlidersProductsTag);
    }

    return Promise.all(giftSlidersProductsTagsResponses);
  }

  async _setFreeGiftPopupShouldShowModalProperty() {
    let freeGiftPopupShouldShowModalProperty;
    let firstAndSecondModalShouldShow = ((this.giftSlidersProducts['level-1-step-1-free-gift-product'].length 
      || this.giftSlidersProducts['level-1-step-2-free-gift-product'].length)
      && this.giftSlidersProducts['level-2-step-1-free-gift-product'].length);
    let firstAndSecondModalShouldNotShow = (!this.giftSlidersProducts['level-1-step-1-free-gift-product'].length 
      && !this.giftSlidersProducts['level-1-step-2-free-gift-product'].length
      && !this.giftSlidersProducts['level-2-step-1-free-gift-product'].length);
    let firstModalShouldShow = ((this.giftSlidersProducts['level-1-step-1-free-gift-product'].length 
      || this.giftSlidersProducts['level-1-step-2-free-gift-product'].length)
      && !this.giftSlidersProducts['level-2-step-1-free-gift-product'].length);
    let secondModalShouldShow = (!this.giftSlidersProducts['level-1-step-1-free-gift-product'].length
      && !this.giftSlidersProducts['level-1-step-2-free-gift-product'].length
      && this.giftSlidersProducts['level-2-step-1-free-gift-product'].length);
    
    if(firstAndSecondModalShouldShow) {
        freeGiftPopupShouldShowModalProperty = 'firstAndSecondModalShouldShow';
    }
    else if(firstAndSecondModalShouldNotShow) {
        freeGiftPopupShouldShowModalProperty = 'firstAndSecondModalShouldNotShow';
    }
    else if(firstModalShouldShow) {
        freeGiftPopupShouldShowModalProperty = 'firstModalShouldShow';
    }
    else if(secondModalShouldShow) {
        freeGiftPopupShouldShowModalProperty = 'secondModalShouldShow';
    }

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          'Free Gift Popup Visible Modal Property': freeGiftPopupShouldShowModalProperty
        }
      })
    });

    let responseCartDrawerAndCartIconBubbleSections = await fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble');
    let dataCartDrawerAndCartIconBubbleSections = await responseCartDrawerAndCartIconBubbleSections.json();
    this._preRenderCartDrawer({
      sections: dataCartDrawerAndCartIconBubbleSections
    });
  }
}

class CartDrawerItems extends CartItems {
  connectedCallback() {
    this.cartDrawerWishlistButtons = this.querySelectorAll('.cart-drawer-wishlist');
    const cartDrawer = this.closest('cart-drawer');
    cartDrawer.calculateVariantOptionsWidths();
    this.FBTproductsSection = this.querySelector('.cart-recommended-products-wrapper');
    this.FBTproductsSection && this.FBTproductsSection.classList.contains('hidden') ? this.FBTproductsSection.classList.remove('hidden') : null;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer-container',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '#cart-icon-bubble',
      }
    ];
  }
}

class CartDrawerWishlist extends HTMLElement {
  constructor() {
    super();
    this.ajaxAPI = new API('ajax');
    this.cart = document.querySelector('cart-drawer');
    this.allowFetchSection = true;
    // Event Listeners
    this.addEventListener('click', this.handleClick.bind(this));
  }

  async render() {
    const WISHLIST_ITEM_SECTION_NAME = 'section-wishlist-item';
    const cartDrawerWishlist = this;
    const wishlistContentsContainer = document.querySelector(".cart-drawer-wishlist-items");
    const wishlistEmptyContainer = document.querySelector(".empty-component-cart-drawer-wishlist");
    wishlistContentsContainer.innerHTML = '';
    wishlistEmptyContainer.classList.add('hidden');
    this.classList.add('loading');

    if(this.allowFetchSection) {
      const listContents = await app.swymApi.getListContents();
      this.allowFetchSection = false;
      const wishlistProductsLength = listContents.length;
      let finishedPromiseCount = 0;
      const wishlistItemSectionNodes = [];
      
      for(let listContent of listContents) {
        const productHandle = listContent.du.split('/').pop();
        const productVariantId = listContent.epi;
        fetch(`${location.origin}/products/${productHandle}?sections=${WISHLIST_ITEM_SECTION_NAME}&variant=${productVariantId}`)
          .then((response) => response.json())
          .then((sectionData) => {
            const wishlistItemSectionNode = new DOMParser().parseFromString(sectionData[WISHLIST_ITEM_SECTION_NAME],'text/html').querySelector('.wishlist-item');
            wishlistItemSectionNodes.push(wishlistItemSectionNode);
          })
          .finally(() => {
            finishedPromiseCount+=1;
            if (finishedPromiseCount == wishlistProductsLength) {
              for(let wishlistItemSectionNode of wishlistItemSectionNodes) {
                wishlistContentsContainer.appendChild(wishlistItemSectionNode);
              }
              cartDrawerWishlist.allowFetchSection = true;
              cartDrawerWishlist.classList.remove('loading');
            }
          });
      }

      if(listContents.length === 0) {
        cartDrawerWishlist.allowFetchSection = true;
        cartDrawerWishlist.classList.remove('loading');
        wishlistEmptyContainer.classList.remove('hidden');
      } 
    } 
  }

  async addToCart(addToCartButton) {
    const properties = addToCartButton.dataset.presale === 'true' ? {'Order Type': 'This product is on Pre Order'} : {};
    const body = {
      quantity: 1,
      id: addToCartButton.dataset.variantId,
      properties,
      sections: this.cart.getSectionsToRender().map((section) => section.id),
    }
    const data = await this.ajaxAPI.cartAdd(body);
    // render and open the cart drawer
    await this.cart.renderContents(data);
    const cartDrawerWrapper = document.querySelector('cart-drawer');
    if (cartDrawerWrapper) cartDrawerWrapper.classList.remove('is-empty');
  }

  async handleClick(event) {
    const addToCartButton = event.target.closest('.wishlist-item-add-to-cart');
    const variantAvaliable = addToCartButton && (addToCartButton.getAttribute('available') === 'true');
    const removeFromWishlistButton = event.target.closest('.wishlist-item-romove-from-wishlist');

    if(addToCartButton && variantAvaliable) {
      this.addToCart(addToCartButton);
    }

    if(removeFromWishlistButton) {
      let deletedProduct = await app.swymApi.deleteFromList({
        epi: +removeFromWishlistButton.dataset.variantId,
        empi: +removeFromWishlistButton.dataset.productId,
        du: location.origin + removeFromWishlistButton.dataset.productUrl,
      });
      this.render();
      let disabledWishlistButtons = document.querySelectorAll('.component-product-card-wishlist.disable[data-variant-id="'+ deletedProduct.epi +'"]');
      for(let disabledWishlistButton of disabledWishlistButtons) {
        disabledWishlistButton.classList.remove('disable');
      }
    }
  } 
}

customElements.define('cart-drawer', CartDrawer);
customElements.define('cart-drawer-items', CartDrawerItems);
customElements.define('component-cart-drawer-wishlist', CartDrawerWishlist);
